import { confirmDialog } from "primereact/confirmdialog";
import { enqueueSnackbar } from "notistack";
import {
  createBank,
  deleteBank,
  getAllBanks,
  updateBank,
} from "../../../services/ValitanApiService";

export const getBanks = async (page = 0, size = 10) => {
  try {
    const response = await getAllBanks(page, size);
    const pageData = response?.data?.data || {};

    return {
      banks: pageData.content || [],
      paginationInfo: {
        totalElements: pageData.totalElements ?? pageData.total_elements ?? 0,
        totalPages: pageData.totalPages ?? pageData.total_pages ?? 0,
        pageNumber: pageData.number ?? 0,
        pageSize: pageData.size ?? size,
        sort: pageData.sort || {},
      },
    };
  } catch (error) {
    console.error("Error fetching banks:", error);
    enqueueSnackbar("Error fetching banks. Please try again.", { variant: "error" });
    return { banks: [], paginationInfo: {} };
  }
};

export const deleteABank = async (id, loadBanks) => {
  try {
    const response = await deleteBank(id);
    if (response?.data?.status === "success") {
      enqueueSnackbar(response.data.message || "Bank deleted successfully.", { variant: "success" });
      await loadBanks();
    } else {
      enqueueSnackbar(response?.data?.message || "Failed to delete bank.", { variant: "error" });
    }
  } catch (error) {
    console.error("Error deleting bank:", error);
    enqueueSnackbar("Failed to delete bank. Please try again.", { variant: "error" });
  }
};

export const confirmDeleteBank = (id, loadBanks) => {
  confirmDialog({
    message: "Are you sure you want to delete this bank?",
    header: "Confirmation",
    icon: "pi pi-question-circle",
    accept: () => deleteABank(id, loadBanks),
    reject: () => {},
  });
};

export const validateBankForm = (name, code, setErrors) => {
  let valid = true;
  const errorsCopy = { name: "", code: "" };

  if (!name.trim()) {
    errorsCopy.name = "Bank name is required";
    valid = false;
  }

  if (!code.trim()) {
    errorsCopy.code = "Bank code is required";
    valid = false;
  }

  setErrors(errorsCopy);
  return valid;
};

export const createOrUpdateBank = async (
  event,
  name,
  code,
  editingBankId,
  loadBanks,
  toggleModal,
  setErrors
) => {
  event.preventDefault();

  if (!validateBankForm(name, code, setErrors)) return;

  const payload = { name, code };

  try {
    const response = editingBankId
      ? await updateBank(editingBankId, payload)
      : await createBank(payload);

    if (response?.data?.status === "success") {
      enqueueSnackbar(response.data.message || "Bank saved successfully.", { variant: "success" });
      toggleModal();
      await loadBanks();
    } else {
      enqueueSnackbar(response?.data?.message || "Failed to save bank.", { variant: "error" });
    }
  } catch (error) {
    console.error("Error saving bank:", error);
    enqueueSnackbar("Error saving bank. Please try again.", { variant: "error" });
  }
};
